// Load up FancyBox
jQuery(document).ready(function() {
    jQuery(".fancybox").fancybox({
        helpers : {
            media: true
        }
    });
});

jQuery(document).foundation();